import { get } from '@core/api/baseApi';
import { ResultResponse, StudyListItemModel } from '@core/types';

const getPatientStudies = async (
  patientId: string,
): Promise<ResultResponse<StudyListItemModel[]>> => await get(`/UserPatient/${patientId}/studies`);

export default getPatientStudies;
